'use client';
import { Typography } from '../Typography';
import { Button } from '../common';

type BaseErrorProps = {
  title: string;
  subtitle: string;
  description?: string;
  onClick: () => void;
  textButton: string;
};

const BaseError = ({
  title,
  subtitle,
  description,
  onClick,
  textButton,
}: BaseErrorProps) => {
  return (
    <div className="flex flex-col">
      <div className="flex min-h-screen flex-col items-center justify-center">
        <Typography.HeadingSemiboldExtraLarge className="mb-4 text-6xl text-content-brand">
          {title}
        </Typography.HeadingSemiboldExtraLarge>
        <h2 className="mb-2 text-2xl font-semibold text-gray-800">
          {subtitle}
        </h2>
        <p className="mb-8 text-lg text-gray-600">{description}</p>
        <Button
          variant="primary"
          onClick={onClick}
          className="text-md mx-auto rounded-full border-4 border-[#dfeff4] px-6 py-6 shadow-md"
        >
          {textButton}
        </Button>
      </div>
    </div>
  );
};

export { BaseError };
